<template>
	<div class="modal fade" ref="modalElem" :id="id" tabindex="-1" :aria-labelledby="'modalLabel' + id" aria-hidden="true">
		<div :class="'modal-dialog ' + sizeClass">
			<div class="modal-content">
				<div class="modal-header">
					<h2 class="modal-title" :id="'modalLabel' + id">{{ title }}</h2>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="modal-body">
					<slot name="body">
						This is the default body!
					</slot>
				</div>
				<div class="modal-footer">
					<slot name="footer">
						<button type="button" class="btn btn-primary btn-lg" data-bs-dismiss="modal">Close</button>
					</slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Modal } from 'bootstrap';

export default {
	props: {
		id: {
			required: true
		},
		title: {
			required: true
		},
		sizeClass: {
			required: false
		},
	},
	data() {
		return {
			modalObj: null,
		}
	},
	mounted() {
		this.modalObj = new Modal(this.$refs.modalElem)
	},
	expose: ['show', 'hide'],
	methods: {
		show() {
			this.modalObj.show();
		},
		hide() {
			this.modalObj.hide();
		}
	}
}
</script>
